import { defaultInspectionOperator } from '#/modules/imsMgmt/settings/inspectionKind/helper/constants';

export function createEmptyInspectionItem() {
  return {
    locked: false,
    itemCode: '',
    itemName: '',
    dataType: 'DECIMAL',
    unit: '',
    required: true,
    remark: '',
    operator: 'BETWEEN',
    scale: '2',
    min: '',
    max: '',
    minInclusive: true,
    maxInclusive: true,
    expectedValue: '',
    options: [{ value: '', label: '' }],
    passingValues: [],
  };
}

function mapExpectedValue(value, dataType) {
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  if (value == null || value === '') {
    return dataType === 'BOOLEAN' ? 'true' : '';
  }
  return String(value);
}

function mapItem(item) {
  const criteria = item?.criteria ?? {};
  const dataType = item?.dataType ?? 'DECIMAL';
  const options = Array.isArray(criteria.options) && criteria.options.length
    ? criteria.options.map((option) => ({
      value: option?.value ?? '',
      label: option?.label ?? '',
    }))
    : [{ value: '', label: '' }];

  return {
    locked: true,
    itemCode: item?.itemCode ?? '',
    itemName: item?.itemName ?? '',
    dataType,
    unit: item?.unit ?? '',
    required: item?.required !== false,
    remark: item?.remark ?? '',
    operator: criteria.operator ?? defaultInspectionOperator(dataType),
    scale: criteria.scale == null ? '2' : String(criteria.scale),
    min: criteria.min ?? '',
    max: criteria.max ?? '',
    minInclusive: criteria.minInclusive !== false,
    maxInclusive: criteria.maxInclusive !== false,
    expectedValue: mapExpectedValue(criteria.expectedValue, dataType),
    options,
    passingValues: Array.isArray(criteria.passingValues) ? criteria.passingValues : [],
  };
}

export function mapInspectionKindToForm(detail) {
  const items = (detail?.items ?? [])
    .filter((item) => item?.status !== 'DEPRECATED')
    .slice()
    .sort((left, right) => (left?.sequence ?? 0) - (right?.sequence ?? 0))
    .map(mapItem);

  return {
    code: detail?.code ?? '',
    name: detail?.name ?? '',
    status: detail?.status ?? 'ACTIVE',
    items: items.length ? items : [createEmptyInspectionItem()],
  };
}

export function collectKnownDataTypes(detail) {
  const known = {};
  (detail?.items ?? []).forEach((item) => {
    if (item?.itemCode && item?.dataType) {
      known[String(item.itemCode).trim().toUpperCase()] = item.dataType;
    }
  });
  return known;
}
